import { RootState } from "../rootReducer"

export const selectConfigState = (state: RootState) => state.config.config
